import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { environment } from '../../../../environments/environment';

// Interfaces
import { IService, IAWSS3, IAWSS3Model } from '../../interfaces';

// Services
import { LogService } from '../log/log.service';
import { FileService } from '../../services';


@Injectable()
export class ServerService implements IService {

	// implements local variables
	_sessionId: string; // = 'testing';
	header: Headers;
	readonly X_SESSION = 'x_session';
	readonly X_VERSION = 'x-version';
	readonly X_SUB_AUTH = 'x-Sub-Auth';
	readonly X_ACEPID = 'x-acepid';
	// implements IService
	name = 'ServerService';
	test(name, value) {
		console.log('testing', name, value);
	}



	constructor(
		private _http: Http,
		private _log: LogService
	) { }

	getSecureUrl(url: any) {
		if (window.location.href.indexOf('localhost') === -1) {
			url = url.replace('http://', 'https://');
		}

		return url;
	}


	get SessionId() {
		return this._sessionId;
	}

	set SessionId(value: string) {
		// this._storageService.setSession(this._storageService.SESSION, value);
		this._sessionId = value;
	}

	private _get = () => {
		const headers = new Headers(
			{
				'Authorization': environment.Token,
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': '*'
			});
		const options = new RequestOptions(
			{ headers: headers }
		);

		const endPoint = environment.APIFullPath + 'session/key/key/signature/sign';

		return this._http.get(endPoint, options)
			.map(m => m.json())
			.retry(2)
			.toPromise();
	}
	load = (): Promise<boolean> => {
		'LOADING HEADER'.logWithObject(this.name, this.header);
		return new Promise((success, fail) => {
			if (this.header) {
				success(true);
			} else {
				this._get().then(session => {
					this.SessionId = session.id;
					this.header = new Headers(
						{
							'Authorization': environment.Token,
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'Access-Control-Allow-Origin': '*',
							'x_session': session.id,
							'x-version': '1'
						});
					'setting header'.logWithObject(this.name, ['header', this.header, this.SessionId]);
					success(true);
				}, error => {
					this.header.append(this.X_SESSION, 'no session id');
					'fail'.logWithObject(this.name, ['header', this.header, error]);
					success(true);
				});
			}
		});

	}

	GetWithEndPoint = (callerAcepid: string, endPoint: string, optionArgs?: RequestOptions): Observable<Response> => {
		'http GetWithEndPoint header'.logWithObject(this.name, [endPoint, this.header]);
		try {

			return Observable.fromPromise(this.load()).mergeMap(success => {
				let options: RequestOptions;
				if (optionArgs) {
					options = optionArgs;
					options.headers.append(this.X_SESSION, this._sessionId);

				} else {
					options = new RequestOptions(
						{ headers: this.header }
					);
				}
				options.headers.delete(this.X_VERSION);
				options.headers.append(this.X_VERSION, '1');

				options.headers.delete(this.X_ACEPID);
				options.headers.append(this.X_ACEPID, callerAcepid);

				'http GetWithEndPoint options'.logWithObject(this.name, [endPoint, options, options.headers.getAll(this.X_VERSION)]);

				return this._http.get(endPoint, options)
					.do(resp => {
						const etag: string = resp.headers.get('ETag');
						this._log.Debug(this.name, ['GetWithEndPoint response', { response: resp, ETag: etag }]);
					});
				// .map(res => res.json());
			});

		} catch (error) {
			console.log(error);
		}
	}

	GetWithAuthWithURL = (acepid: string, url: string, optionArgs?: RequestOptions): Observable<Response> => {
		'GetWithAuthWithURL'.logWithObject(this.name, [{ url: url }]);
		const endPoint = url.replace(':4200', '');
		return this.GetWithEndPoint(acepid, endPoint, optionArgs);
	}

	GetWithAuth = (acepid: string, routMap: string, optionArgs?: RequestOptions): Observable<Response> => {
		try {

			const endPoint = routMap.indexOf(environment.APIHost) > -1 ? routMap : environment.APIHost + routMap;
			'GetWithAuth'.logWithObject(this.name, [{ endpoint: endPoint }]);
			return this.GetWithEndPoint(acepid, endPoint, optionArgs);

		} catch (error) {
			console.log(error);
		}
	}

	GetByURL = (caller: string, url: string, optionArgs: RequestOptions): Observable<Response> => {
		this._log.Debug(this.name, [{ caller: caller, url: url, options: optionArgs }]);
		return this._http.get(url, optionArgs)
			.do(resp => {
				this._log.Debug(this.name, ['GetWithEndPoint response', { response: resp }]);
			});
	}

	PostWithAuthWithURL = (acepid: string, url: string, body: any, optionArgs?: RequestOptions): Observable<Response> => {
		//if not dev environment make sure its on https MB 12/18/2017
		url = url.toLowerCase().indexOf(environment.APIHost.toLowerCase()) > -1 ? url : environment.APIHost + url;
		url = this.getSecureUrl(url);
		this._log.Debug(this.name, ['http PostWithAuthWithURL header', { url: url, header: this.header }]);
		return Observable.fromPromise(this.load()).mergeMap(success => {
			let options: RequestOptions;
			if (optionArgs) {
				options = optionArgs;
				options.headers.append(this.X_SESSION, this._sessionId);

			} else {
				options = new RequestOptions(
					{ headers: this.header }
				);
			}
			options.headers.delete(this.X_VERSION);
			options.headers.append(this.X_VERSION, '1');

			options.headers.delete(this.X_ACEPID);
			options.headers.append(this.X_ACEPID, acepid);

			'http PostWithAuth options'.logWithObject(
				this.name,
				[
					{
						endpoint: url,
						options: options,
						headers: options.headers, // .getAll(this.X_VERSION),
						body: body
					}
				]);
			return this._http.post(url, body, options);
			// .map(res => res.json());
		});
	}

	PostWithAutEndPoint = (acepid: string, url: string, body: any, optionArgs?: RequestOptions): Observable<Response> => {
		//if not dev environment make sure its on https MB 12/18/2017
		// url = url.toLowerCase().indexOf(environment.APIHost.toLowerCase()) > -1 ? url : environment.APIHost + url;
		url = this.getSecureUrl(url);
		this._log.Debug(this.name, ['http PostWithAuthWithURL header', { url: url, header: this.header }]);
		return Observable.fromPromise(this.load()).mergeMap(success => {
			let options: RequestOptions;
			if (optionArgs) {
				options = optionArgs;
				//options.headers.append(this.X_SESSION, this._sessionId);

			} else {
				options = new RequestOptions(
					{ headers: this.header }
				);
			}
			// options.headers.delete(this.X_VERSION);
			// options.headers.append(this.X_VERSION, '1');

			// options.headers.delete(this.X_ACEPID);
			// options.headers.append(this.X_ACEPID, acepid);

			'http PostWithAuth options'.logWithObject(
				this.name,
				[
					{
						endpoint: url,
						options: options,
						headers: options.headers, // .getAll(this.X_VERSION),
						body: body
					}
				]);
			return this._http.post(url, body, options);
			//.map(res => res.json());
		});
	}

	PostWithAuth = (acepid: string, routMap: string, body: any, optionArgs?: RequestOptions): Observable<Response> => {
		const endPoint = environment.APIHost + routMap;
		this._log.Debug(this.name, ['http PostWithAuth header', { endpoint: endPoint, header: this.header }]);

		return this.PostWithAuthWithURL(acepid, endPoint, body, optionArgs);
	}

	PutWithAuthWithURL = (acepid: string, url: string, body: any, optionArgs?: RequestOptions): Observable<Response> => {
		//if not dev environment make sure its on https MB 12/18/2017
		url = url.toLowerCase().indexOf(environment.APIHost.toLowerCase()) > -1 ? url : environment.APIHost + url;
		url = this.getSecureUrl(url);
		'http PutWithAuthWithURL header'.logWithObject(this.name, [url, this.header]);
		return Observable.fromPromise(this.load()).mergeMap(success => {
			let options: RequestOptions;
			if (optionArgs) {
				options = optionArgs;
				options.headers.append(this.X_SESSION, this._sessionId);

			} else {
				options = new RequestOptions(
					{ headers: this.header }
				);
			}
			options.headers.delete(this.X_VERSION);
			options.headers.append(this.X_VERSION, '1');

			options.headers.delete(this.X_ACEPID);
			options.headers.append(this.X_ACEPID, acepid);

			'http PutWithAuthWithURL options'.logWithObject(
				this.name,
				[
					{
						endpoint: url,
						options: options,
						headers: options.headers, // .getAll(this.X_VERSION),
						body: body
					}
				]);
			return this._http.put(url, body, options);
			// .map(res => res.json());
		});
	}

	PutWithAuth = (acepid: string, routMap: string, body: any, optionArgs?: RequestOptions): Observable<Response> => {
		const endPoint = environment.APIHost + routMap;
		'http PutWithAuth header'.logWithObject(this.name, [endPoint, this.header]);
		return this.PutWithAuthWithURL(acepid, endPoint, body, optionArgs);
	}

	DeleteWithAuthWithURL = (caller: string, url: string, optionArgs?: RequestOptions): Observable<Response> => {
		//if not dev environment make sure its on https MB 12/18/2017
		url = url.toLowerCase().indexOf(environment.APIHost.toLowerCase()) > -1 ? url : environment.APIHost + url;
		url = this.getSecureUrl(url);
		'http DeleteWithAuthWithURL header'.logWithObject(this.name, [url, this.header]);

		return Observable.fromPromise(this.load()).mergeMap(success => {
			let options: RequestOptions;
			if (optionArgs) {
				options = optionArgs;
				options.headers.append(this.X_SESSION, this._sessionId);

			} else {
				options = new RequestOptions(
					{ headers: this.header }
				);
			}
			options.headers.delete(this.X_VERSION);
			options.headers.append(this.X_VERSION, '1');

			options.headers.delete(this.X_ACEPID);
			options.headers.append(this.X_ACEPID, caller);

			'http DeleteWithAuthWithURL options'.logWithObject(
				this.name,
				[
					{
						endpoint: url,
						options: options,
						headers: options.headers // .getAll(this.X_VERSION),
					}
				]);

			//MB if no url just return true..MB..used when something is being removed and has not made it to the server yet
			if (url == '') {
				return Observable.empty<Response>();
			}

			return this._http.delete(url, options);
			// .map(res => res.json());
		});

	}

	DeleteWithAuth = (caller: string, routMap: string, optionArgs?: RequestOptions): Observable<Response> => {
		const endPoint = environment.APIHost + routMap;
		'http DeleteWithAuth header'.logWithObject(this.name, [endPoint, this.header]);
		return this.DeleteWithAuthWithURL(caller, endPoint);
	}

	SaveQandAFile(stephtml: string[], acepid: string, file: IAWSS3) {
		//need to turn the stephtml into a byte array or file so we can add the "file" to the formdata below.
		// 	const myhtmlfile: File = new File(stephtml, file.Key, {type: 'text/html'});

		// 	let fData = new FormData();
		// 	fData.append('file', myhtmlfile);

		// 	const h = new Headers(
		// 		{
		// 			'Access-Control-Allow-Origin': '*',
		// 			'x-version': '1'
		// 			//, 'type': 'text/html'
		// 		}
		// 	);

		// 	const options = new RequestOptions(
		// 		{ headers: h }
		// 	);


		// 	const endPoint = `/AWS/S3/Upload/application/${file.ApplicationNumber}/file/${file.Name}/ext/${file.Ext}/order/${file.Order}`;

		// 	this._log.Debug(this.name, ['upload file aws s3', endPoint, fData, h, stephtml]);

		// 	return this.PostWithAuth(acepid, endPoint, fData, options)
		// 		.map(response => {
		// 			if (response.status === 200) {
		// 				const body = response.json();
		// 				const data = <IAWSS3Model>body.Data;
		// 				return data;
		// 			} else {
		// 				this._log.Error(this.name, ['get file', response]);
		// 				return undefined;
		// 			}
		// 		})
		// 		.toPromise();
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/server/server.service.ts